module.exports = __webpack_public_path__ + "assets/f21bb2669a98027aff173a1dc875dedf.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-theme/app/fonts/Gotham-Bold.woff
 ** module id = 1732
 ** module chunks = 1
 **/